var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconShineCombinedSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 23,
    viewBox: "0 0 174 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14812_28124)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.07476,
    cy: 77.9967,
    rx: 2.07476,
    ry: 77.9967,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 9.00586 14.485)",
    fill: "url(#paint0_linear_14812_28124)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_14812_28124)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.89263,
    cy: 64.0884,
    rx: 1.89263,
    ry: 64.0884,
    transform: "matrix(-0.00131068 -0.999999 1 -0.000314281 23.209 12.8249)",
    fill: "url(#paint1_linear_14812_28124)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48.002,
    y: 9.99872,
    width: 79,
    height: 1,
    fill: "url(#paint2_linear_14812_28124)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14812_28124",
    x: 0.618678,
    y: 1.92565,
    width: 172.763,
    height: 20.9203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19261,
    result: "effect1_foregroundBlur_14812_28124"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_14812_28124",
    x: 14.8218,
    y: 0.634151,
    width: 144.946,
    height: 20.5559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.19261,
    result: "effect1_foregroundBlur_14812_28124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14812_28124",
    x1: 4.01427,
    y1: 155.861,
    x2: 3.88329,
    y2: 2.2126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14812_28124",
    x1: 3.66188,
    y1: 128.068,
    x2: 3.56494,
    y2: 1.81804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00836175,
    stopColor: "#4022FA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509705,
    stopColor: "#3843E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#261494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14812_28124",
    x1: 48.002,
    y1: 10.4987,
    x2: 127.002,
    y2: 10.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522498,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShineCombinedSmall);
export default __webpack_public_path__ + "static/media/IconShineCombinedSmall.38f0a3a1ad8b6cde24b7e5ea1963dd43.svg";
export { ForwardRef as ReactComponent };